<template>
  <div
    :class="$style.group"
    gk-form-custom-group
    :valid="result.valid"
    :invalid="result.invalid"
    :readonly="readonly"
    :disabled="disabled"
  >
    <FormValidity
      :group="group"
      :field="field"
      type="hidden"
      :validity="validity && !disabled && !readonly"
      :readonly="readonly"
      :disabled="disabled"
      :rule="rule"
      v-model="currentValue"
      :trigger="['input']"
      :customRule="customRule"
      :delay="0"
      @input="handleInput"
      @validate="onValidated"
    >
      <input type="hidden" v-model="currentValue" />
    </FormValidity>

    <slot />
   
    <transition name="fade">
      <span :class="`${prefixCls}-tips`" v-if="tips || $slots.tips">
        <slot name="tips">{{tips}}</slot>
      </span>

      <span :class="`${prefixCls}-error`" v-if="result.message || $slots.error">
        <slot name="error">{{result.message}}</slot>
      </span>
    </transition>
  </div>
</template>

<script>
import VueTypes from 'vue-types'
import validityProps from './validity.props'
import FormValidity from './FormValidity'

const prefixCls = 'gkui-form'

export default {
  name: 'gkui-form-custom-group',
  components: {
    FormValidity
  },
  props: Object.assign({
    type: VueTypes.string.def('custom'),
    readonly: VueTypes.bool.def(false),
    disabled: VueTypes.bool.def(false),
    tips: VueTypes.string.def('')
  }, validityProps),
  data () {
    return {
      currentValue: this.value,
      focused: false,
      result: {}
    }
  },
  computed: {
    prefixCls () {
      return prefixCls
    },
    classes () {
      const className = [
        `${prefixCls}-element`,
        `${prefixCls}-element-${this.type}`
        // ,
        // {
          // [`${prefixCls}-focused`]: !!this.focused,
          // [`${prefixCls}-valid`]: !!this.result.valid,
          // [`${prefixCls}-invalid`]: !!this.result.invalid,
        //   [`${prefixCls}-disabled`]: !!this.disabled,
        //   [`${prefixCls}-readonly`]: !!this.readonly
        // }
      ]

      return className
    }
  },
  watch: {
    value (value) {
      this.currentValue = value
    }
  },
  created () {
  },
  methods: {
    handleInput (value, event) {
      this.$emit('input', value, event)
    },
    onValidated (result) {
      this.result = result
      this.$emit('validate', result)
    }
  }
}
</script>

<style lang="scss" module>
.group {
  position: relative;
}
</style>
